import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-or-later
import { useId, useEffect } from 'react';
import { describedBy, FieldHost } from '../FieldHost.js';
import { useLanguage } from '../../i18n/LanguageProvider.js';
import { translateAnswerOption, translateField } from '../../i18n/translate.js';
import { answerOptionKey, answerOptionLabel, asAnswerOptionArray } from './answerOption.js';
export function MultiSelect(props) {
    const { item, value, errors, disabled, onChange } = props;
    const { lang } = useLanguage();
    const groupId = useId();
    const options = item.answerOption ?? [];
    const selected = asAnswerOptionArray(value, options);
    const selectedKeys = new Set(selected.map(answerOptionKey));
    useEffect(() => {
        let needsUpdate = false;
        if (value !== undefined) {
            if (!Array.isArray(value)) {
                needsUpdate = true;
            }
            else if (value.length !== selected.length) {
                needsUpdate = true;
            }
            else {
                for (let i = 0; i < value.length; i++) {
                    if (value[i] !== selected[i]) {
                        needsUpdate = true;
                        break;
                    }
                }
            }
        }
        if (needsUpdate && selected.length > 0) {
            onChange(selected);
        }
    }, [value, selected, onChange]);
    function toggle(option) {
        const key = answerOptionKey(option);
        const next = selectedKeys.has(key)
            ? selected.filter((o) => answerOptionKey(o) !== key)
            : [...selected, option];
        onChange(next.length === 0 ? undefined : next);
    }
    const itemWithoutLabel = { ...item, text: undefined };
    return (_jsx(FieldHost, { item: itemWithoutLabel, errors: errors, controlId: groupId, children: (ctx) => (_jsxs("fieldset", { id: groupId, disabled: disabled === true, "data-multi-select": "true", "aria-invalid": ctx.hasError || undefined, "aria-describedby": describedBy(ctx), children: [item.text !== undefined ? (_jsx("legend", { children: translateField(item, 'text', lang, item.text) })) : null, options.map((o) => {
                    const key = answerOptionKey(o);
                    return (_jsxs("label", { children: [_jsx("input", { type: "checkbox", value: key, checked: selectedKeys.has(key), onChange: () => {
                                    toggle(o);
                                } }), translateAnswerOption(item, key, answerOptionLabel(o), lang)] }, key));
                })] })) }));
}
//# sourceMappingURL=MultiSelect.js.map